import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Form } from 'grab-ui';
import { UCD_ACTION_TYPES, UCD_RESOURCE_NAMES, UCD_ROUTES_LINK } from 'omega-rtc/constants/ucd';
import ShowIfAuthorized from 'omega-rtc/components/form/ucd/common/ShowIfAuthorized';

import './CreateTridentCampaign.scss';

import _ from 'lodash';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';
import {
  GET_TRIDENT_CAMPAIGN,
  getTridentCampaign,
  UPDATE_TRIDENT_CAMPAIGN,
  updateTridentCampaign,
} from 'omega-rtc/actions/ucd';
import TridentCampaignPage from 'omega-rtc/views/ucd/trident/TridentCampaignPage';
import { TridentCampaignFormData } from 'omega-rtc/types/ucd/campaign';
import { hasJustSuccess, isRequestsPending } from 'omega-rtc/utils/request-state-utils';
import Toastr from 'omega-rtc/utils/toastr-util';
import { Dimmer, Loader } from 'semantic-grab-ui';
import {
  constructConditionFormData,
  constructConditionFormPayload,
  constructLimitFormData,
} from 'omega-rtc/utils/simple-scenario-utils';


type Props = {
  updateTridentCampaignRequest: Any,
  updateCampaign: Function,
  getCampaign: Function,
  projectID: string,
  campaignID: string,
  user: any
}

class EditTridentCampaign extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      currentPageIndex: 1,
      formData: {},
    };
    const { getCampaign, projectID, campaignID } = this.props;
    getCampaign(projectID, campaignID);
  }

  componentDidMount() {
    const toastrMessage = sessionStorage.getItem('toastrMessage');
    if (toastrMessage) {
      Toastr.success(toastrMessage);
      sessionStorage.removeItem('toastrMessage');
    }
  }

  handleSubmitForm = (formData: TridentCampaignFormData) => {
    // Set state so if the HTTP response is not successfull the rendered children component still showing the latest form value
    const currentPageIndex = 2;
    this.setState({ formData, currentPageIndex });


    const updatedFormData = _.cloneDeep(formData);
    updatedFormData.condition = constructConditionFormData(updatedFormData);

    const { updateCampaign, projectID, campaignID, user } = this.props;
    updateCampaign({
      user: user.email,
      campaign: updatedFormData,
    }, projectID, campaignID);
  };


  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const prevRequestStatus = _.get(this.props, 'getTridentCampaignRequest');
    const nextRequestStatus = _.get(nextProps, 'getTridentCampaignRequest');

    // Only to perform one time when it receive response from GetTridentCampaign
    if (prevRequestStatus.isPending && nextRequestStatus.isSuccessful) {
      this.onCampaignDataLoaded(nextProps);
    }


    const prevSubmitRequest = this.props.updateTridentCampaignRequest;
    const currentSubmitRequest = nextProps.updateTridentCampaignRequest;

    // when it has just successfully submitted the form
    if (hasJustSuccess(prevSubmitRequest, currentSubmitRequest)) {
      Toastr.success('Campaign is updated successfully');
      this.props.router.push(
        UCD_ROUTES_LINK.CAMPAIGN_VIEW(this.props.projectID, this.props.campaignID),
      );
    }
  }

  onCampaignDataLoaded(props: Props) {
    const formData = _.get(props, 'tridentCampaignView.campaign', {});
    const { condition, mandatoryCondition } = constructConditionFormPayload(formData.condition);
    formData.condition = condition;
    formData.mandatoryCondition = mandatoryCondition;
    formData.limit = constructLimitFormData(formData.limit);
    this.setState({ formData, currentPageIndex: 2 });
  }


  render() {
    // Wait until trident campaign has been loaded
    if (_.isEmpty(_.get(this.props, 'tridentCampaignView', {}))) {
      return <Dimmer inverted active> <Loader /> </Dimmer>;
    }


    const { formData, currentPageIndex } = this.state;
    const { updateTridentCampaignRequest, params } = this.props;

    // When submitting the form and pending for Http Response
    if (isRequestsPending(updateTridentCampaignRequest)) {
      return <Dimmer inverted active> <Loader /> </Dimmer>;
    }

    return (
      <div className={'ucd-basic trident-campaign-page'}>
        <h3 className={'trident-campaign-page-title'}>Edit Trident Campaign</h3>
        <TridentCampaignPage
          params={params}
          formData={formData}
          currentPageIndex={currentPageIndex}
          handleSubmitForm={this.handleSubmitForm}
          isEditPage
        />
      </div>
    );
  }
}

const mapStateToProps = (state: StoreState, ownProps: Object) => {
  const userPermissions = state.app.user.userPermissions;
  return {
    projectID: ownProps.params.entityID,
    campaignID: ownProps.params.campaignID,
    user: state.app.user,
    userPermissions,
    tridentCampaignView: state.ucd.tridentCampaignView,
    updateTridentCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(UPDATE_TRIDENT_CAMPAIGN),
      {},
    ),
    getTridentCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(GET_TRIDENT_CAMPAIGN),
      {},
    ),
  };
};


const mapDispatchToProps = dispatch => ({
  updateCampaign: (data, projectID, campaignID) => {
    dispatch(updateTridentCampaign(data, projectID, campaignID));
  },
  getCampaign: (projectID, campaignID) => {
    dispatch(getTridentCampaign(projectID, campaignID));
  },
});


const FormHOC = Form.create();
const TridentCampaignEditPageAuthorized = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormHOC(EditTridentCampaign));


// page-level access control
const TridentCampaignEditPageComponent = (props: Props) => (
  <ShowIfAuthorized
    conditions={[
      {
        resource: UCD_RESOURCE_NAMES.campaign,
        action: UCD_ACTION_TYPES.update,
      },
    ]}
    unauthorizedContent={
      <Alert
        message="You don't have permission to edit campaign"
        showIcon
        type="error"
      />
    }
  >
    <TridentCampaignEditPageAuthorized {...props} />
  </ShowIfAuthorized>
);


export default TridentCampaignEditPageComponent;

